import getCharacteristicPrefixes from './getCharacteristicPrefixes'
//---------------------------------------
// save current editable characteristics
//---------------------------------------
export default function saveCurrentEditableCharacteristics(obj) {
  // -------------------
  // define empty array
  // -------------------
  let original_chars = {}
  // -----------------------------
  // get characteristic prefixes
  // -----------------------------
  const chars = getCharacteristicPrefixes()
  // -----------
  // loop chars
  // -----------
  chars.forEach((c) => {
    let char_value = c
    let char_min = c + '_min'
    let char_max = c + '_max'
    let char_dice_roll = c + '_dice_roll'
    let char_rolled = c + '_rolled'
    let char_improvs_tot = c + '_improvs_tot'
    // ---------------------------------------
    // saves current editable characteristics
    // ---------------------------------------
    original_chars[char_value] = obj[char_value]
    original_chars[char_min] = obj[char_min]
    original_chars[char_max] = obj[char_max]
    original_chars[char_dice_roll] = obj[char_dice_roll]
    original_chars[char_rolled] = obj[char_rolled]
    original_chars[char_improvs_tot] = obj[char_improvs_tot]
  })
  return original_chars
}
